import React from 'react';
import {
  BreadcrumbContainer,
  EachBreadcrumb,
} from './BreadcrumbsStyles.styles';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FaChevronRight } from 'react-icons/fa';

// Breadcrumbs
const BreadCrumbs = React.memo(
  ({ one, oneLink, two, twoLink, three, style, variant = 'dark' }) => {
    const navigate = useNavigate();

    return (
      <BreadcrumbContainer style={style}>
        {one && (
          <EachBreadcrumb variant={variant}>
            <span onClick={() => navigate(oneLink)}>{one?.slice(0, 35)}</span>
            <FaChevronRight className="breadcrumb-icon" />
          </EachBreadcrumb>
        )}

        {two && !three && (
          <EachBreadcrumb variant={variant}>
            <span className="current">{two?.slice(0, 35)}</span>
          </EachBreadcrumb>
        )}

        {two && three && (
          <EachBreadcrumb variant={variant}>
            <span onClick={() => navigate(twoLink)}>{two?.slice(0, 35)}</span>
            <FaChevronRight className="breadcrumb-icon" />
          </EachBreadcrumb>
        )}

        {three && (
          <EachBreadcrumb>
            <span className="current">{three}</span>
          </EachBreadcrumb>
        )}
      </BreadcrumbContainer>
    );
  }
);
BreadCrumbs.displayName = 'Breadcrumbs';
BreadCrumbs.propTypes = {
  one: PropTypes.string,
  oneLink: PropTypes.string,
  two: PropTypes.string,
  twoLink: PropTypes.string,
  three: PropTypes.string,
  style: PropTypes.object,
  variant: PropTypes.oneOf(['light', 'dark']),
};

export default BreadCrumbs;
